import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { PlanningScenarioFindManyQueryInterface } from '@zaoblako/shared/modules/finance/dtos/planning-scenario/planning-scenario-find-many-query.dto';
import { Observable } from 'rxjs';
import { PlanningScenarioPageInterface } from '@zaoblako/shared/modules/finance/dtos/planning-scenario/planning-scenario-page.dto';
import { PlanningScenarioFindOneQueryInterface } from '@zaoblako/shared/modules/finance/dtos/planning-scenario/planning-scenario-find-one-query.dto';
import { PlanningScenarioFindInterface } from '@zaoblako/shared/modules/finance/dtos/planning-scenario/planning-scenario-find.dto';

@Injectable({
  providedIn: 'root'
})
export class PlanningScenarioService extends BaseService {
  protected baseUrl = '/finance/plan-fact/planning-scenario';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findWithPagination(
    queryParams: PlanningScenarioFindManyQueryInterface
  ): Observable<PlanningScenarioPageInterface> {
    return this.findPage(queryParams);
  }

  public findPage(queryParams: PlanningScenarioFindManyQueryInterface): Observable<PlanningScenarioPageInterface> {
    return this.http.get<PlanningScenarioPageInterface>(`${this.baseUrl}/items`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public findDefault(queryParams?: PlanningScenarioFindOneQueryInterface): Observable<PlanningScenarioFindInterface> {
    return this.http.get<PlanningScenarioFindInterface>(`${this.baseUrl}/default`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public findUseInBrsTaskAnalytics(
    queryParams?: PlanningScenarioFindOneQueryInterface
  ): Observable<PlanningScenarioFindInterface> {
    return this.http.get<PlanningScenarioFindInterface>(`${this.baseUrl}/use-in-brs-task-analytics`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restoreOne(id: number): Observable<PlanningScenarioFindInterface> {
    return this.http.post<PlanningScenarioFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }
}
